import { render, staticRenderFns } from "./OrganizationPhoto.vue?vue&type=template&id=472ccfe2&"
import script from "./OrganizationPhoto.vue?vue&type=script&lang=js&"
export * from "./OrganizationPhoto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports